import {
    CTRL_SYS_ROLE_LIST,
    CTRL_SYS_ROLE_DETAILS,
    CTRL_SYS_PERMISSION_CATALOG,
    CTRL_SYS_ROLE_CREATE,
    CTRL_SYS_ROLE_UPDATE,
    CTRL_SYS_ROLE_SET_PERMISSIONS,
    CTRL_SYS_ROLE_DEACTIVATE,
} from '../../index.types';

export const getSystemRoles = (data) => ({ type: CTRL_SYS_ROLE_LIST, data });
export const getSystemRoleDetails = (data) => ({ type: CTRL_SYS_ROLE_DETAILS, data });
export const getPermissionCatalog = (data) => ({ type: CTRL_SYS_PERMISSION_CATALOG, data });
export const createSystemRole = (data) => ({ type: CTRL_SYS_ROLE_CREATE, data });
export const updateSystemRole = (data) => ({ type: CTRL_SYS_ROLE_UPDATE, data });
export const setSystemRolePermissions = (data) => ({ type: CTRL_SYS_ROLE_SET_PERMISSIONS, data });
export const deactivateSystemRole = (data) => ({ type: CTRL_SYS_ROLE_DEACTIVATE, data });
